import { getBaseFeature } from '@/assets/style/variable'

const styObj = {
  default: {
    ...getBaseFeature(),
    // --- 色 / 背景 / 圆角（与原先一致）---
    '--fl-more-bg': '#ffffff',
    '--fl-more-radius': '12px 0px 12px 12px',
    '--fl-text-strong': '#333333',
    '--fl-divider': '#f2f2f2',
    '--fl-page-base': '#ffffff',
    '--fl-bg-page': `url(${require('@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/page_bg.png')})`,
    '--fl-avatar-border': '#ffffff',
    '--fl-avatar-radius': '50%',
    '--fl-primary': '#a338fc',
    '--fl-progress-color': '#A338FC',
    '--fl-progress-track': '#ffe9fc',
    '--fl-text-secondary': '#666666',
    '--fl-progress-shadow': '#a338fc',
    '--fl-progress-radius': '6px',
    '--fl-text-muted': '#999999',
    '--fl-title-banner': '#ffffff',
    '--fl-accent-soft': '#b8bdfe',
    '--fl-bg-page-day': `url(${require('@/assets/packageAssets/views/P2_Page/FriendshipLevel/default/day_bg.png')})`,
    '--fl-reward-panel-bg': '#f9fbff',
    '--fl-reward-panel-radius': '12px',
    '--fl-reward-panel-border': '#f9fbff',
    '--fl-tooltip-bg': '#ffffff',
    '--fl-tooltip-text': '#000',
    '--fl-popup-surface': '#ffffff',
    '--fl-popup-radius': '12px',
    '--fl-btn-fill': '#a338fc',
    '--fl-btn-fill-text': '#ffffff',
    '--fl-popup-btn-radius': '20px',
    '--fl-nav-title': '#333333',
    '--fl-progress-inner-radius': '10px',
    '--fl-step-line': '#b8bdfe',
    '--fl-step-line-radius': '2px',
    '--fl-step-active-title': '#000',
    '--fl-dialog-overlay': 'rgba(0, 0, 0, 0.5)',
    '--fl-dialog-shell': 'linear-gradient(135deg, #98edfe 0%, #9ba3f9 51%, #9beefe 100%)',
    '--fl-dialog-shell-radius': '18px',
    '--fl-dialog-head-fade': 'rgba(255, 255, 255, 0.5)',
    '--fl-dialog-body': '#fdfdfd',
    '--fl-dialog-body-radius': '12px',
    '--fl-dialog-ok': '#8e96f9',
    '--fl-dialog-ok-radius': '24px',
    '--fl-send-panel-bg': '#fdfdfd',
    '--fl-send-panel-radius': '12px',
    '--fl-send-primary': '#a338fc',
    '--fl-send-primary-radius': '24px',
    '--fl-send-secondary-bg': '#ffffff',
    '--fl-send-secondary-radius': '24px',
    '--fl-send-secondary-text': '#a338fc',
    '--fl-send-secondary-border': '#a338fc',
    '--fl-guide-scrim': 'rgba(0, 0, 0, 0.7)',
    '--fl-guide-chip-radius': '20px',
    '--fl-guide-chip-border': '#ffffff',
    '--fl-on-dark': '#ffffff',
    '--fl-guide-dot': '#f9fbff',
    '--fl-guide-dot-ring': 'rgba(77, 77, 77, 0.6)',
    '--fl-guide-line': 'linear-gradient(0deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%)',
    '--fl-corner-mask-radius': '50%',
    '--fl-swipe-dot': '#e6e5e7',
    '--fl-swipe-dot-on': '#b2b2b2',
    '--fl-swipe-dot-radius': '2px',
    '--fl-tooltip-arrow': '#ffffff',
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName && styObj[this.packageName]) {
        return styObj[this.packageName]
      }
      return styObj.default
    },
  },
}
